import ArrowLeft from "../../../icons/arrow-left.svg";
import ArrowLeft2 from "../../../icons/arrow-left-2.svg";
import ArrowRight from "../../../icons/arrow-right.svg";
import ArrowRightButton from "../../../icons/arrow-right-button.svg";
import Chevron from "../../../icons/chevron.svg";
import CircleArrow2 from "../../../icons/circle_arrow.svg";
import CircleArrow from "../../../icons/circle-arrow.svg";
import Coins from "../../../icons/coins.svg";
import ForwardArrow from "../../../icons/forward-arrow.svg";
import Returned from "../../../icons/returned.svg";
import RightArrow from "../../../icons/rightArrow.svg";
export const replacedRtlIconsMap = new Map();
replacedRtlIconsMap.set(ArrowRight, ArrowLeft2);
replacedRtlIconsMap.set(ArrowLeft2, ArrowRight);
replacedRtlIconsMap.set(ForwardArrow, ArrowLeft2);
replacedRtlIconsMap.set(ArrowLeft, RightArrow);
replacedRtlIconsMap.set(RightArrow, ArrowLeft);
export const flippedRtlIcons = [Coins, Returned, Chevron, CircleArrow, CircleArrow2, ArrowRightButton];
//# sourceMappingURL=rtlAffectedIcons.js.map